import { render, staticRenderFns } from "./ItemModal.vue?vue&type=template&id=71025f0f&scoped=true&"
import script from "./ItemModal.vue?vue&type=script&lang=js&"
export * from "./ItemModal.vue?vue&type=script&lang=js&"
import style0 from "./ItemModal.vue?vue&type=style&index=0&id=71025f0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71025f0f",
  null
  
)

export default component.exports